<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const props = defineProps({
  conversationLabels: {
    type: Array,
    required: true,
  },
  funnelStage: {
    type: Object,
    default: null,
  },
});
const emit = defineEmits(['open-label-menu']);

const accountLabels = useMapGetter('labels/getLabels');

const activeLabels = computed(() => {
  return accountLabels.value.filter(({ title }) =>
    props.conversationLabels.includes(title)
  );
});
</script>

<template>
  <div>
    <div
      v-if="activeLabels.length || $slots.before"
      class="flex items-center flex-shrink min-w-0 flex-row flex-wrap gap-y-1 overflow-visible"
    >
      <slot name="before" />
      <woot-label
        v-for="(label, index) in activeLabels"
        :key="label ? label.id : index"
        :title="label.title"
        :color="label.color"
        :tag-icon-size="16"
        variant="smooth"
        icon-only
        role="button"
        tabindex="0"
        :aria-label="label.title"
        class="!mb-0 max-w-[calc(100%-0.5rem)] cursor-pointer"
        small
        @click="emit('open-label-menu', $event)"
        @keydown.enter="emit('open-label-menu', $event)"
        @keydown.space="emit('open-label-menu', $event)"
      />
    </div>
  </div>
</template>
